import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["searchTxt", "itemEl", "emptyEl"];

  // Applies the active search to newly saved or replaced library rows.
  // Called by Stimulus when an itemEl target connects after a Turbo Stream update.
  itemElTargetConnected() {
    this.filter();
  }

  // Filters library titles while retaining the selected editor's contents.
  // Called by input#company-document-search on input->company-document-list#filter.
  filter() {
    const query = this.searchTxtTarget.value.trim().toLocaleLowerCase();
    let hasMatches = false;
    for (const item of this.itemElTargets) {
      const isMatch = item.querySelector("strong").textContent.toLocaleLowerCase().includes(query);
      item.hidden = !isMatch;
      hasMatches ||= isMatch;
    }
    if (this.hasEmptyElTarget) this.emptyElTarget.hidden = !query || hasMatches;
  }

  // Highlights the document only after its editor has successfully loaded.
  // Called by the workspace on turbo:frame-load->company-document-list#refresh.
  refresh(event) {
    if (event.target.id !== "company-documents-editor") return;
    // Turbo replaces frame contents, so read the newly rendered document identity.
    const selectedId = event.target.querySelector("[data-company-document-selection]")?.dataset.documentId;
    for (const item of this.itemElTargets) {
      const isSelected = item.dataset.documentId === selectedId;
      item.classList.toggle("is-selected", isSelected);
      if (isSelected) item.setAttribute("aria-current", "page");
      else item.removeAttribute("aria-current");
    }
  }
}
